import dayjs from "dayjs";
import { formatDatetimeLocalized } from "../date";

export const formatDateToDateTimeDisplay = (date: Date | string | null) => {

  if (!date || !dayjs(date).isValid()) {

    return "-"
  }
  // return formatDateIfValid(date, { formatTemplate, fallbackValue: " - " });
  return formatDatetimeLocalized(date) || "-"
};
